import React, { Component } from "react";
import firebase, { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    greeting1: "Hello",
    greeting2: ", how may I help you?",
    login: "Please log in to access my services, or enter your details below.",
    user: " user",
  },
  ja: {
    greeting1: "こんにちは",
    greeting2: "、どのようにお手伝いできますか？",
    login:
      "サービスにアクセスするにはログインしてください、または以下に詳細を入力してください。",
    user: "",
  },
  es: {
    greeting1: "Hola",
    greeting2: ", ¿en qué puedo ayudarte?",
    login:
      "Por favor, inicie sesión para acceder a mis servicios, o ingrese sus datos a continuación.",
    user: "",
  },
});

class Logincheck extends Component {
  state = {
    user: null,
  };

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
      } else {
        this.setState({ user: null });
      }
    });

    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const { user } = this.state;

    return (
      <div>
        {user ? (
          user.displayName === null ? (
            <div>
              {localizationStrings.greeting1 +
                localizationStrings.user +
                localizationStrings.greeting2}
            </div>
          ) : (
            <div>
              {localizationStrings.greeting1 +
                " " +
                user.displayName +
                localizationStrings.greeting2}
            </div>
          )
        ) : (
          <div>{localizationStrings.login}</div>
        )}
      </div>
    );
  }
}

export default Logincheck;
